// hooks/useArticleViews.js
import { useEffect, useRef } from 'react';
import { incrementArticleViews } from '../services/api';

export const useArticleViews = (articleId, delay = 5000) => {
  const timerRef = useRef(null);
  const hasIncrementedRef = useRef(false);

  useEffect(() => {
    if (!articleId || hasIncrementedRef.current) return;

    // Nettoyer le timer précédent si il existe
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Démarrer le timer pour incrémenter les vues
    timerRef.current = setTimeout(async () => {
      try {
        const result = await incrementArticleViews(articleId);
        if (result.success) {
          hasIncrementedRef.current = true;
        }
      } catch (error) {
        console.error('Erreur lors de l\'incrémentation des vues:', error);
      }
    }, delay);

    // Cleanup function
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [articleId, delay]);

  // Reset quand l'article change
  useEffect(() => {
    hasIncrementedRef.current = false;
  }, [articleId]);
};
